import { post, get } from './api';

export default {
  getTypes: async function (id) {
    return await get('/membership/get_types');
  },
  request: async function (data) {
    return await post('/membership/request', data);
  },
  connect: async function (data) {
    return await post('/membership/connect', data);
  },
  cancel: async function (data) {
    return await post('/membership/cancel', data);
  },
  disconnect: async function (data) {
    return await post('/membership/disconnect', data);
  },
  check: async function (data) {
    return await post('/membership/check', data);
  }
};
